import Button from '@atlaskit/button/standard-button';
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl-next';

import { useAnalytics } from '@townsquare/analytics';
import { useThemeStore } from '@townsquare/theme';
import { TitanEAPCrossFlow } from '@townsquare/titan-eap-cross-flow';
import { TitanEapCrossFlowObject } from '@townsquare/titan-eap-cross-flow/types';

import { IntroPopupContent } from '../style';

import darkImage from './images/IntroPopupContentOne-Dark.svg';
import lightImage from './images/IntroPopupContentOne-Light.svg';
import { messages } from './messages';

export const IntroContentInternals = (props: TitanEapCrossFlowObject) => {
  const intl = useIntl();
  const analytics = useAnalytics();
  const [theme] = useThemeStore();

  const { isOrgAdmin, adminButtonHref, handleOptInOrRequestTrial } = props;

  useEffect(() => {
    void analytics.track('popup', 'viewed', {}, 'atlasBenefitsPopup');
  }, [analytics]);

  const renderIntroContent = () => {
    return (
      <Stack space="space.200" alignInline="start">
        <Inline>
          <img
            alt={intl.formatMessage(messages.imageAtl)}
            width="294"
            height="175"
            src={theme === 'light' ? lightImage : darkImage}
          />
        </Inline>
        <Inline>
          <Stack space="space.100" alignInline="start">
            <Inline>
              <Heading size="medium">
                {isOrgAdmin
                  ? intl.formatMessage(messages.earlyAccessToGoalsAdminHeading)
                  : intl.formatMessage(messages.earlyAccessToGoalsEndUserHeading)}
              </Heading>
            </Inline>
            <Inline>
              <Text>
                {isOrgAdmin
                  ? intl.formatMessage(messages.earlyAccessToGoalsAdminDescription)
                  : intl.formatMessage(messages.earlyAccessToGoalsEndUserDescription)}
              </Text>
            </Inline>
          </Stack>
        </Inline>
        <Inline grow="fill">
          <Button
            appearance="primary"
            shouldFitContainer
            href={isOrgAdmin ? adminButtonHref : undefined}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleOptInOrRequestTrial}
          >
            {isOrgAdmin
              ? intl.formatMessage(messages.earlyAccessToGoalsAdminButton)
              : intl.formatMessage(messages.earlyAccessToGoalsEndUserButton)}
          </Button>
        </Inline>
      </Stack>
    );
  };

  return (
    <IntroPopupContent>
      <Box padding="space.300">{renderIntroContent()}</Box>
    </IntroPopupContent>
  );
};

const IntroContent = () => {
  return (
    <TitanEAPCrossFlow context="intro-content-flag" isFullPage={false}>
      {props => {
        return <IntroContentInternals {...props} />;
      }}
    </TitanEAPCrossFlow>
  );
};

export default IntroContent;
